"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2577],{

/***/ 59557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ FormErrorsBlock; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./main/javascripts/utils/ObjectUtil.ts
var ObjectUtil = __webpack_require__(76614);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./node_modules/humps/humps.js
var humps = __webpack_require__(56264);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
// EXTERNAL MODULE: ./main/javascripts/utils/StringUtil.tsx
var StringUtil = __webpack_require__(56896);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/form/ValidationErrorsBlock.tsx











var ValidationErrorsBlock = function ValidationErrorsBlock(props) {
  var namespace = props.namespace,
      errors = props.errors;

  if (!errors || (0,ObjectUtil/* isObjectEmpty */.nK)(errors)) {
    return null;
  }

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t; // console.log(errors);
  // key(field name)からnamespaceへの変換


  var convertGroupToNamespace = function convertGroupToNamespace(groupKey) {
    var namespaces = Object.keys(FormConstants/* FormNamespaces */.Z); // labelのlocaleはmanagerとcompany_xxxxで共通にしている

    var camelizeGroupKey = (0,humps.camelize)(groupKey.replace("company_", ""));
    return namespaces.find(function (namespace) {
      return camelizeGroupKey.toLowerCase().indexOf(namespace.toLowerCase()) !== -1;
    });
  };

  var localizeKey = function localizeKey(key, groupNamespace) {
    var currentNamespace = groupNamespace || namespace;
    var keyString = t("".concat(currentNamespace, ".").concat((0,humps.camelize)(key)));

    if (keyString.indexOf("".concat(currentNamespace, ".").concat((0,humps.camelize)(key))) === 0) {
      keyString = key;
    }

    return keyString;
  };

  var generateGroupKeyString = function generateGroupKeyString(key, index, parentKeyString) {
    var groupNamespace = convertGroupToNamespace(key);
    var groupKeyString = localizeKey(key, groupNamespace);
    var keyString = index !== undefined && !Number.isNaN(index) ? "".concat(groupKeyString).concat(index + 1) : groupKeyString;

    if (parentKeyString) {
      keyString = t("form.errors.groupFormat", {
        group: parentKeyString,
        label: keyString
      });
    }

    return keyString;
  };

  var renderValidationErrorMessage = function renderValidationErrorMessage(key, error, groupKeyString) {
    var keyString = localizeKey(key);

    if (groupKeyString) {
      keyString = t("form.errors.groupFormat", {
        group: groupKeyString,
        label: keyString
      });
    }

    var localizedMessage;

    if (typeof error.message === "object") {
      localizedMessage = t("form.errors.messages.".concat(error.message.key), error.message.options);
    } else {
      localizedMessage = t("form.errors.messages.".concat(error.message));
    }

    var labeledMessage;

    if (error.type === "server") {
      if (groupKeyString) {
        labeledMessage = t("form.errors.groupFormat", {
          group: groupKeyString,
          label: (0,StringUtil/* nl2br */.hU)(error.message)
        });
      } else {
        labeledMessage = (0,StringUtil/* nl2br */.hU)(error.message);
      }

      console.log(labeledMessage);
    } else if (localizedMessage.indexOf("form.errors.") === 0) {
      labeledMessage = (0,StringUtil/* nl2br */.hU)(error.message);
    } else {
      labeledMessage = t("form.errors.format", {
        label: keyString,
        message: localizedMessage
      });
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
      css: errorStyle,
      children: labeledMessage
    }, key);
  };

  var renderValidationErrorObject = function renderValidationErrorObject(key, errorObject, parentKeyString) {
    return Object.keys(errorObject).flatMap(function (errorKey) {
      var error = errorObject[errorKey];

      if (Array.isArray(error)) {
        return error.flatMap(function (errorObject, index) {
          var newParentKeyString = generateGroupKeyString(errorKey, index, parentKeyString);
          return errorObject ? renderValidationErrorObject(errorKey, errorObject, newParentKeyString) : undefined;
        });
      } else {
        return renderValidationErrorMessage(errorKey, error, parentKeyString);
      }
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
    css: blockStyle,
    children: Object.keys(errors).map(function (key) {
      var error = errors[key];

      if (Array.isArray(error)) {
        return error.map(function (errorObject, index) {
          var parentKeyString = generateGroupKeyString(key, index);
          return errorObject ? renderValidationErrorObject(key, errorObject, parentKeyString) : undefined;
        });
      } else if (typeof error === "object" && error.type === undefined) {
        return renderValidationErrorObject(key, error);
      } else {
        return renderValidationErrorMessage(key, error);
      }
    })
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, " 1.6rem;margin:0;" + ( true ? "" : 0),  true ? "" : 0);
var errorStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";color:", colorStyle/* accentColor.alertColor */.z.alertColor, ";" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js + 1 modules
var withTranslation = __webpack_require__(67375);
// EXTERNAL MODULE: ./main/javascripts/components/form/InputError.tsx
var InputError = __webpack_require__(44464);
// EXTERNAL MODULE: ./main/javascripts/constants/ErrorCodes.ts
var ErrorCodes = __webpack_require__(93227);
// EXTERNAL MODULE: ./main/javascripts/components/icon/Icon.tsx
var Icon = __webpack_require__(65147);
;// CONCATENATED MODULE: ./main/javascripts/components/form/SubmitErrorsBlock.tsx













var SubmitErrorsBlockComponent = function SubmitErrorsBlockComponent(props) {
  var errorCode = props.errorCode,
      errorMessages = props.errorMessages,
      t = props.t;
  var submitErrorLocaleKey = !errorCode || errorCode !== ErrorCodes/* ErrorCodes.form */.S.form ? "component:form.submitError" : "component:form.submitFormError";
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: [SubmitErrorsBlock_blockStyle, props.styles,  true ? "" : 0,  true ? "" : 0],
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: iconStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
        styleKey: "caution"
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputError/* InputError */.p, {
      errorMessage: t(submitErrorLocaleKey),
      styles: mainErrorStyle
    }), (errorMessages || []).map(function (errorMessage) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputError/* InputError */.p, {
        errorMessage: errorMessage,
        styles: inputErrorStyle
      }, errorMessage);
    })]
  });
};

var SubmitErrorsBlock = (0,withTranslation/* withTranslation */.Z)(["component"])(SubmitErrorsBlockComponent);
var SubmitErrorsBlock_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, " 2.5rem;box-sizing:border-box;position:relative;background:", (0,colorStyle/* shadeColorLog */.wJ)((0,colorStyle/* hex2rgba */.rW)(colorStyle/* accentColor.alertColor */.z.alertColor), 0.8), ";border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";" + ( true ? "" : 0),  true ? "" : 0);
var mainErrorStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0;margin:0;display:block;background:0;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";" + ( true ? "" : 0),  true ? "" : 0);
var inputErrorStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " 0 0;margin:0;display:block;background:0;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";" + ( true ? "" : 0),  true ? "" : 0);
var iconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:", spaceStyle/* space.atom */.D.atom, ";left:", spaceStyle/* space.atom */.D.atom, ";display:block;font-size:1.5rem;color:", colorStyle/* accentColor.alertColor */.z.alertColor, ";text-align:center;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/form/FormErrorsBlock.tsx

var _excluded = ["form"];











var FormErrorsBlock = function FormErrorsBlock(props) {
  var namespace = props.namespace,
      errors = props.errors,
      _props$hideValidation = props.hideValidationErrors,
      hideValidationErrors = _props$hideValidation === void 0 ? false : _props$hideValidation;

  if (!errors || (0,ObjectUtil/* isObjectEmpty */.nK)(errors)) {
    return null;
  }

  var form = errors.form,
      validationErrors = (0,objectWithoutProperties/* default */.Z)(errors, _excluded);

  var isFormError = !!form; // form keyに全体のエラーを格納する

  var formErrorMessages = isFormError && (0,ObjectUtil/* isObjectEmpty */.nK)(validationErrors) ? [errors === null || errors === void 0 ? void 0 : errors.form.message] : null;
  var errorCode = isFormError ? null : ErrorCodes/* ErrorCodes.form */.S.form;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: FormErrorsBlock_blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubmitErrorsBlock, {
      errorCode: errorCode,
      errorMessages: formErrorMessages
    }), validationErrors && !(0,ObjectUtil/* isObjectEmpty */.nK)(validationErrors) && !hideValidationErrors && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ValidationErrorsBlock, {
      namespace: namespace,
      errors: validationErrors
    })]
  });
};
var FormErrorsBlock_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("background:", (0,colorStyle/* shadeColorLog */.wJ)((0,colorStyle/* hex2rgba */.rW)(colorStyle/* accentColor.alertColor */.z.alertColor), 0.8), ";border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";margin:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 1399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ InputAutosuggestBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58808);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_autosuggest__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_Label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35183);
/* harmony import */ var main_javascripts_components_form_InputError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44464);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_constants_DestinationTypes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25551);
/* harmony import */ var main_javascripts_components_atoms_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74303);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58589);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35944);


var _excluded = ["onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var InputAutosuggestBlock = function InputAutosuggestBlock(props) {
  var _props$namespace = props.namespace,
      namespace = _props$namespace === void 0 ? "common" : _props$namespace,
      label = props.label,
      input = props.input,
      fetchDestinationSuggest = props.fetchDestinationSuggest,
      suggestions = props.suggestions,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onSelected = props.onSelected,
      suggestOptions = props.suggestOptions,
      onClear = props.onClear,
      error = props.error,
      inputBlockRef = props.inputBlockRef,
      preventClearWhenInputBoxIsBlank = props.preventClearWhenInputBoxIsBlank,
      forceDisplayCloseButton = props.forceDisplayCloseButton,
      _props$disableOnFocus = props.disableOnFocusRequest,
      disableOnFocusRequest = _props$disableOnFocus === void 0 ? false : _props$disableOnFocus,
      _props$alwaysShowSugg = props.alwaysShowSuggestions,
      alwaysShowSuggestions = _props$alwaysShowSugg === void 0 ? false : _props$alwaysShowSugg,
      _props$borderColorSty = props.borderColorStyleKey,
      borderColorStyleKey = _props$borderColorSty === void 0 ? "none" : _props$borderColorSty;
  var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .useFormContext */ .Gc)(),
      register = _useFormContext.register;

  var _register = register(input.name),
      onChange = _register.onChange,
      registerProps = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_register, _excluded);

  var onChangeDestination = function onChangeDestination(event, params) {
    var value = event.target.value;

    if (input.onChange) {
      input.onChange(event);
    }

    onSuggestionsFetchRequested({
      value: value,
      reason: "input-changed"
    });

    if (!preventClearWhenInputBoxIsBlank && params && params.newValue === "" && onClear) {
      onClear();
    }
  };

  var onSuggestionSelected = function onSuggestionSelected(_, data) {
    if (input.onChange) {
      input.onChange(data.suggestion.longName);
    }

    onSelected(data.suggestion);
  };

  var getSuggestionValue = function getSuggestionValue(suggestion) {
    return suggestion.name;
  };

  var renderSuggestion = function renderSuggestion(suggestion, _) {
    var iconType = "pin";

    switch (suggestion.destinationType) {
      case main_javascripts_constants_DestinationTypes__WEBPACK_IMPORTED_MODULE_5__/* .DestinationTypes.region */ ._.region:
        iconType = "city";
        break;

      case main_javascripts_constants_DestinationTypes__WEBPACK_IMPORTED_MODULE_5__/* .DestinationTypes.hotel */ ._.hotel:
        iconType = "hotel";
        break;

      case main_javascripts_constants_DestinationTypes__WEBPACK_IMPORTED_MODULE_5__/* .DestinationTypes.airport */ ._.airport:
        iconType = "airplane";
        break;

      default:
    }

    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)("div", {
      css: suggestStyle,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)("div", {
        css: iconStyle,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(main_javascripts_components_atoms_Icon__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .J, {
          styleKey: iconType
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)("div", {
        css: suggestionValueBlockStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)("div", {
          css: suggestionValueStyle,
          children: suggestion.name
        }), suggestion.label && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)("div", {
          css: suggestionLabelStyle,
          children: suggestion.label
        })]
      })]
    });
  };

  var onSuggestionsFetchRequested = function onSuggestionsFetchRequested(request) {
    if (!request.value) {
      return;
    }

    if (request.reason !== "input-changed" && (disableOnFocusRequest || request.reason !== "input-focused")) {
      return;
    }

    fetchDestinationSuggest(_objectSpread({
      text: request.value
    }, suggestOptions || {}));
  };

  var onSuggestionsClearRequested = function onSuggestionsClearRequested() {
    console.log("clear");
  };

  var onClearInput = function onClearInput(event) {
    event.preventDefault();

    if (inputRef.current) {
      inputRef.current.value = "";
    }

    if (onClear) {
      onClear();
    }
  }; // react hook formのonChangeと合成


  var onInputChange = function onInputChange(e) {
    void onChange(e);
    onChangeDestination(e);
  };

  var renderInputComponent = function renderInputComponent(inputProps) {
    // デフォルトではreact-autosuggestとreact hook formの両方でrefを登録する必要があるため
    // react-autosuggestのfocusInputOnSuggestionClickをfalseにして
    // refを不要にする
    // もしfocusInputOnSuggestionClickが必要な場合はrefを合成する
    // https://github.com/moroshko/react-autosuggest/issues/646
    // https://github.com/facebook/react/issues/13029#issuecomment-497641073
    // react hook formとreact-autosuggestのonBlurと合成
    // 両方にonBlurが登録されており
    // 合成しないとautosuggestのドロップダウンがエリア外がクリックされても閉じなくなる
    var onInputBlur = function onInputBlur(e) {
      if (inputProps.onBlur) {
        inputProps.onBlur(e);
      }

      if (registerProps.onBlur) {
        registerProps.onBlur(e);
      }

      if (onBlur) {
        onBlur();
      }
    };

    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
      children: [(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.createElement)("input", _objectSpread(_objectSpread(_objectSpread({}, inputProps), registerProps), {}, {
        onChange: onInputChange,
        onBlur: onInputBlur // spreadでkeyを渡すとwarningが発生するため直接指定する
        ,
        key: inputProps.key
      })), forceDisplayCloseButton || inputProps.value ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)("button", {
        css: clearButtonStyle,
        onClick: onClearInput,
        type: "button",
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(main_javascripts_components_atoms_Icon__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .J, {
          styleKey: "close"
        })
      }) : ""]
    });
  };

  var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
    return value.trim().length > 0;
  };

  var shouldAlwaysRenderSuggestions = function shouldAlwaysRenderSuggestions() {
    return true;
  };

  var shouldRenderSuggestions = alwaysShowSuggestions ? shouldAlwaysRenderSuggestions : defaultShouldRenderSuggestions;
  var hasError = !!error;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    ref: inputBlockRef,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(main_javascripts_components_form_Label__WEBPACK_IMPORTED_MODULE_3__/* .Label */ ._, _objectSpread({}, label)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_emotion_react__WEBPACK_IMPORTED_MODULE_14__.ClassNames, {
      children: function children(_ref) {
        var css = _ref.css;
        var theme = {
          container: css(inputContainerStyle),
          suggestionsContainer: css(suggestionsContainerStyle),
          suggestionsContainerOpen: css(suggestionsContainerOpenStyle),
          suggestionsList: css(suggestionsListStyle),
          suggestion: css(suggestBlockStyle)
        };

        var InputProps = _objectSpread(_objectSpread({}, input), {}, {
          onChange: onInputChange,
          onFocus: onFocus,
          className: hasError ? css(inputWithErrorStyle, inputStyle, inputBorderColorStyle[borderColorStyleKey]) : css(inputStyle, inputBorderColorStyle[borderColorStyleKey]),
          autoComplete: "off",
          autoCorrect: "off"
        }); // TODO: InputErrorStyle


        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)((react_autosuggest__WEBPACK_IMPORTED_MODULE_2___default()), {
            suggestions: suggestions,
            onSuggestionsFetchRequested: onSuggestionsFetchRequested,
            onSuggestionsClearRequested: onSuggestionsClearRequested,
            getSuggestionValue: getSuggestionValue,
            inputProps: InputProps,
            theme: theme,
            renderSuggestion: renderSuggestion,
            onSuggestionSelected: onSuggestionSelected,
            focusInputOnSuggestionClick: false // suggestを選択したらblur
            ,
            renderInputComponent: renderInputComponent,
            shouldRenderSuggestions: shouldRenderSuggestions,
            ref: inputRef
          }), error && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(main_javascripts_components_form_InputError__WEBPACK_IMPORTED_MODULE_4__/* .InputError */ .p, {
            namespace: namespace,
            errorMessage: error.message,
            label: input.name
          })]
        });
      }
    })]
  });
};
var inputContainerStyle =  true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0;
var inputStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)("padding-right:2rem;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.form */ .JB.form, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontWeight.regular */ .Ue.regular, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";caret-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .accentColor.primaryColor */ .z.primaryColor, ";padding:0.125rem ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom1_5x */ .D.atom1_5x, " 0;box-sizing:border-box;margin:0;width:100%;height:40px;border:1px solid;border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_10__/* .borderRadius.normal */ .E.normal, ";appearance:none;&:focus{outline:none;border-bottom-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .accentColor.primaryColor */ .z.primaryColor, ";}&::placeholder{color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.disabledColor */ .zP.disabledColor, ";}" + ( true ? "" : 0),  true ? "" : 0);
var inputWithErrorStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)("border-bottom-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .accentColor.alertColor */ .z.alertColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var suggestionsContainerStyle =  true ? {
  name: "wpmoml",
  styles: "display:none;box-sizing:border-box"
} : 0;
var suggestionsContainerOpenStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)("display:block;position:absolute;top:37px;margin:0;max-height:600px;background-color:white;width:100%;z-index:100;box-shadow:0 6px 30px rgba(40, 40, 40, 0.1);border-top:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .accentColor.primaryColor */ .z.primaryColor, ";overflow:auto;pointer-events:none;" + ( true ? "" : 0),  true ? "" : 0);
var suggestionsListStyle =  true ? {
  name: "1lamgov",
  styles: "margin:0;padding:0;list-style-type:none;pointer-events:auto"
} : 0;
var suggestBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)("border-bottom:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .borderColor.primaryLightColor */ .tv.primaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var suggestStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)("position:relative;margin:0;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom2x */ .D.atom2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, " 3rem;cursor:pointer;color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";&:hover{background-color:$ground;}" + ( true ? "" : 0),  true ? "" : 0);
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)("padding:calc(", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, " - (", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .lineHeight.body1 */ .Nv.body1, " - ", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.body */ .JB.body, ") / 2) ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0); // const inputErrorStyle = css`
//   padding: ${space.atom0_5x} 0 0;
// `;

var iconStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)("position:absolute;top:0.5rem;left:0.75rem;font-size:1.5rem;vertical-align:middle;color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";opacity:0.4;" + ( true ? "" : 0),  true ? "" : 0);
var suggestionValueBlockStyle =  true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0;
var suggestionValueStyle =  true ? {
  name: "1e5de7k",
  styles: "flex:1;width:60%"
} : 0;
var suggestionLabelStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)("display:block;width:40%;padding:0.2rem 0 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.caption */ .JB.caption, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.disabledColor */ .zP.disabledColor, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .lineHeight.caption3 */ .Nv.caption3, ";text-align:right;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var clearButtonStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)("position:absolute;top:50%;right:0;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.body */ .JB.body, ";background:none;border:0;transform:translateY(-50%);width:40px;height:40px;cursor:pointer;color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";outline:none;opacity:0.6;transition:opacity 0.4s ease;display:flex;align-items:center;justify-content:center;&:hover{opacity:1;}" + ( true ? "" : 0),  true ? "" : 0);
var inputBorderColorStyle = {
  none:  true ? {
    name: "1oscket",
    styles: "border-color:white"
  } : 0,
  primary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)("border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .borderColor.primaryDarkColor */ .tv.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  secondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__.css)("border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .borderColor.secondaryLightColor */ .tv.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 83827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ SuggestionFieldButton; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36716);
/* harmony import */ var _form_Label__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35183);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58589);
/* harmony import */ var _form_InputError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44464);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var SuggestionFieldButton = function SuggestionFieldButton(props) {
  var namespace = props.namespace,
      name = props.name,
      label = props.label,
      longName = props.longName,
      placeholder = props.placeholder,
      onClick = props.onClick,
      _props$borderColorSty = props.borderColorStyleKey,
      borderColorStyleKey = _props$borderColorSty === void 0 ? "none" : _props$borderColorSty,
      error = props.error;
  var buttonStyles = longName ? buttonStyle : buttonPlaceholderStyle;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_form_Label__WEBPACK_IMPORTED_MODULE_5__/* .Label */ ._, _objectSpread({}, label)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("button", {
      type: "button",
      css: [buttonStyles, buttonBorderColorStyle[borderColorStyleKey],  true ? "" : 0,  true ? "" : 0],
      onClick: onClick,
      children: longName || placeholder
    }), error && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_form_InputError__WEBPACK_IMPORTED_MODULE_7__/* .InputError */ .p, {
      namespace: namespace,
      errorMessage: error.message,
      label: name
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("padding:calc(", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom, " - (", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .lineHeight.body1 */ .Nv.body1, " - ", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.body */ .JB.body, ") / 2) ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var buttonStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.form */ .JB.form, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontWeight.regular */ .Ue.regular, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";caret-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryColor */ .z.primaryColor, ";padding:0.125rem ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom1_5x */ .D.atom1_5x, " 0;box-sizing:border-box;margin:0;width:100%;height:40px;border:1px solid;border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_6__/* .borderRadius.normal */ .E.normal, ";background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .backgroundColor.primaryLightColor */ .Cz.primaryLightColor, ";text-align:left;appearance:none;&:focus{outline:none;}" + ( true ? "" : 0),  true ? "" : 0);
var buttonPlaceholderStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonStyle, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.disabledColor */ .zP.disabledColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var buttonBorderColorStyle = {
  none:  true ? {
    name: "1oscket",
    styles: "border-color:white"
  } : 0,
  primary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .borderColor.primaryDarkColor */ .tv.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  secondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .borderColor.secondaryLightColor */ .tv.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 50193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ SuggestionPicker; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Icon/index.ts
var Icon = __webpack_require__(74303);
// EXTERNAL MODULE: ./main/javascripts/constants/DestinationTypes.ts
var DestinationTypes = __webpack_require__(25551);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/suggestionPicker/SuggestionItem.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var SuggestionItem = function SuggestionItem(props) {
  var suggestion = props.suggestion,
      onSelected = props.onSelected;

  var onItemSelected = function onItemSelected() {
    onSelected(suggestion);
  };

  var iconType = "pin";

  switch (suggestion.destinationType) {
    case DestinationTypes/* DestinationTypes.region */._.region:
      iconType = "city";
      break;

    case DestinationTypes/* DestinationTypes.hotel */._.hotel:
      iconType = "hotel";
      break;

    case DestinationTypes/* DestinationTypes.airport */._.airport:
      iconType = "airplane";
      break;

    default:
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: suggestStyle,
    onClick: onItemSelected,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: iconStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
        styleKey: iconType
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: suggestionValueBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: suggestionValueStyle,
        children: suggestion.name
      }), suggestion.label && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: suggestionLabelStyle,
        children: suggestion.label
      })]
    })]
  });
};
var suggestStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;margin:0;padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, " 4rem;cursor:pointer;color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";&:hover{background-color:#f5f5f5;}" + ( true ? "" : 0),  true ? "" : 0);
var iconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:0.625rem;left:1.5rem;font-size:1.5rem;display:flex;align-items:center;color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";opacity:0.3;" + ( true ? "" : 0),  true ? "" : 0);
var suggestionValueBlockStyle =  true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0;
var suggestionValueStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("flex:1;width:60%;font-size:", typographyStyle/* fontSize.body */.JB.body, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";" + ( true ? "" : 0),  true ? "" : 0);
var suggestionLabelStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:block;width:40%;padding:0.2rem 0 0 ", spaceStyle/* space.atom */.D.atom, ";font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";color:", colorStyle/* textColor.disabledColor */.zP.disabledColor, ";line-height:", typographyStyle/* lineHeight.caption3 */.Nv.caption3, ";text-align:right;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/skeleton/RectSkeleton.tsx
var RectSkeleton = __webpack_require__(66356);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
;// CONCATENATED MODULE: ./main/javascripts/components/suggestionPicker/SuggestionItemSkeleton.tsx








var SuggestionItemSkeleton = function SuggestionItemSkeleton() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: SuggestionItemSkeleton_suggestStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: SuggestionItemSkeleton_iconStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RectSkeleton/* RectSkeleton */.I, {})
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: SuggestionItemSkeleton_suggestionValueBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: suggestionSkeletonStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RectSkeleton/* RectSkeleton */.I, {})
      })
    })]
  });
};
var SuggestionItemSkeleton_suggestStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;margin:0;padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
var SuggestionItemSkeleton_iconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:", typographyStyle/* fontSize.headline */.JB.headline, ";height:", typographyStyle/* fontSize.headline */.JB.headline, ";margin:0 1.25rem 0 ", spaceStyle/* space.atom */.D.atom, ";border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";overflow:hidden;" + ( true ? "" : 0),  true ? "" : 0);
var SuggestionItemSkeleton_suggestionValueBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;align-items:center;width:50%;height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";" + ( true ? "" : 0),  true ? "" : 0);
var suggestionSkeletonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;height:", typographyStyle/* fontSize.body */.JB.body, ";border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";overflow:hidden;" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/suggestionPicker/SuggestionPicker.tsx


var _excluded = ["onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function SuggestionPicker_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














// 現在モバイル専用
var SuggestionPicker = function SuggestionPicker(props) {
  var name = props.name,
      suggestions = props.suggestions,
      placeholder = props.placeholder,
      isLoading = props.isLoading,
      onRequest = props.onRequest,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onSelected = props.onSelected,
      onClear = props.onClear,
      suggestOptions = props.suggestOptions;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      setValue = _useFormContext.setValue,
      control = _useFormContext.control;

  var _register = register(name),
      onChange = _register.onChange,
      registerProps = (0,objectWithoutProperties/* default */.Z)(_register, _excluded);

  var currentValue = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: name
  });
  var suggestionBlockRef = (0,react.useRef)();
  (0,react.useEffect)(function () {
    if (visualViewport) {
      visualViewport.addEventListener("resize", onResizeWindow);
    }

    return function () {
      if (visualViewport) {
        visualViewport.removeEventListener("resize", onResizeWindow);
      }
    };
  }, []);

  var onResizeWindow = function onResizeWindow() {
    if (suggestionBlockRef.current && visualViewport) {
      suggestionBlockRef.current.style.height = "calc(".concat(window.visualViewport.height, "px - 7rem - ").concat(spaceStyle/* space.atom */.D.atom, ")");
    }
  };

  var onDestinationChange = function onDestinationChange(event) {
    var value = event.target.value;

    if (value) {
      onRequest(_objectSpread({
        text: value
      }, suggestOptions || {}));
    }

    if (!value && onClear) {
      onClear();
    }
  };

  var onSuggestionSelected = function onSuggestionSelected(suggestion) {
    onSelected(suggestion);
  };

  var onClearInput = function onClearInput(event) {
    event.preventDefault();
    setValue(name, "");

    if (onClear) {
      onClear();
    }
  }; // react hook formのonChangeと合成


  var onInputChange = function onInputChange(e) {
    void onChange(e);
    onDestinationChange(e);
  };

  var onInputBlur = function onInputBlur(e) {
    if (registerProps.onBlur) {
      registerProps.onBlur(e);
    }

    if (onBlur) {
      onBlur();
    }
  };

  var renderItems = function renderItems() {
    if (isLoading) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItemSkeleton, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItemSkeleton, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItemSkeleton, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItemSkeleton, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItemSkeleton, {})]
      });
    } else {
      return suggestions.map(function (suggestion) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItem, {
          suggestion: suggestion,
          onSelected: onSuggestionSelected
        }, suggestion.id);
      });
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: inputBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", _objectSpread(_objectSpread({
        css: inputStyle,
        name: name,
        placeholder: placeholder
      }, registerProps), {}, {
        onChange: onInputChange,
        onBlur: onInputBlur,
        onFocus: onFocus
      })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: searchIconStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
          styleKey: "search"
        })
      }), currentValue ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
        css: clearButtonStyle,
        onClick: onClearInput,
        type: "button",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: clearButtonIconStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
            styleKey: "close"
          })
        })
      }) : ""]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: suggestionBlockStyle,
      ref: suggestionBlockRef,
      children: renderItems()
    })]
  });
};
var inputBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;padding:", spaceStyle/* space.atom2x */.D.atom2x, ";border-bottom:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var inputStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.form */.JB.form, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";padding:0 2.5rem 0 2.5rem;box-sizing:border-box;margin:0;width:100%;height:3rem;border:0;appearance:none;background-color:", colorStyle/* backgroundColor.ground */.Cz.ground, ";border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";&:focus{outline:none;}&::placeholder{color:", colorStyle/* textColor.disabledColor */.zP.disabledColor, ";}" + ( true ? "" : 0),  true ? "" : 0); // const inputWithErrorStyle = css`
//   border-bottom-color: ${accentColor.alertColor};
// `;

var blockStyle =  true ? {
  name: "1wv4onu",
  styles: "position:relative;height:100%"
} : 0;
var clearButtonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:50%;right:", spaceStyle/* space.atom2x */.D.atom2x, ";background:none;border:0;transform:translateY(-50%);width:40px;height:40px;cursor:pointer;outline:none;opacity:0.6;transition:opacity 0.4s ease;display:flex;align-items:center;justify-content:center;&:hover{opacity:1;}&:before{content:\"\";position:absolute;display:block;width:1.25rem;height:1.25rem;background-color:", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";border-radius:50%;}" + ( true ? "" : 0),  true ? "" : 0);
var clearButtonIconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;align-items:center;position:relative;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var searchIconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;align-items:center;position:absolute;top:50%;left:1.875rem;font-size:", typographyStyle/* fontSize.body */.JB.body, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";transform:translateY(-50%);" + ( true ? "" : 0),  true ? "" : 0);
var suggestionBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("height:calc(100% - 3rem - ", spaceStyle/* space.atom */.D.atom, ");overflow:auto;padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 25551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ DestinationTypes; }
/* harmony export */ });
var DestinationTypes = {
  region: "region",
  hotel: "hotel",
  airport: "airport"
};

/***/ }),

/***/ 93227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ ErrorCodes; }
/* harmony export */ });
var ErrorCodes = {
  form: "form",
  expired: "expired",
  priceChanged: "price_changed",
  outOfStock: "out_of_stock",
  priceConfirmation: "price_confirmation",
  duplicateBooking: "duplicate_booking",
  allFailed: "all_failed",
  automaticallyCancelled: "automatically_cancelled",
  partiallyFailed: "partially_failed",
  commitError: "commit_error"
};

/***/ }),

/***/ 63591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ convertServerErrorToForm; }
/* harmony export */ });
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_0__);

var convertServerErrorToForm = function convertServerErrorToForm(serverErrors, setErrorFn) {
  if (serverErrors !== null && serverErrors !== void 0 && serverErrors.messages) {
    setErrorFn("form", {
      type: "server",
      message: serverErrors.messages.join("\n")
    });
  }

  if (serverErrors !== null && serverErrors !== void 0 && serverErrors.fieldMessages) {
    serverErrors.fieldMessages.map(function (fieldError) {
      var parseField = function parseField(error) {
        var parentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        var key = (0,humps__WEBPACK_IMPORTED_MODULE_0__.decamelize)(Object.keys(error)[0]);

        if (parentKey) {
          key = "".concat(parentKey, ".").concat(key);
        }

        var value = Object.values(error)[0];

        if (Array.isArray(value) && typeof value[0] === "object") {
          value.map(function (subValue) {
            parseField(subValue, key);
            return null;
          });
        } else {
          setErrorFn(key, {
            type: "server",
            message: value.join("\n")
          });
        }
      };

      parseField(fieldError);
    });
  }
};

/***/ })

}]);